import { memo } from 'react';
import { FaMoon, FaSun } from 'react-icons/fa';

import { IconButton, useColorMode, useColorModeValue } from '@chakra-ui/react';

export const ColorModeSwitcher = memo((props) => {
	const { toggleColorMode } = useColorMode();
	const text = useColorModeValue('dark', 'light');
	const SwitchIcon = useColorModeValue(FaMoon, FaSun);

	return (
		<IconButton
			aria-label={`Switch to ${text} mode`}
			color="current"
			fontSize="sm"
			icon={<SwitchIcon />}
			id="toggleTheme"
			marginLeft="2"
			size="md"
			variant="ghost"
			onClick={toggleColorMode}
			{...props}
		/>
	);
});
